var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 4.172 1 2.757 1.879 1.879C2.757 1 4.172 1 7 1H11C13.828 1 15.243 1 16.121 1.879C17 2.757 17 4.172 17 7V15C17 17.828 17 19.243 16.121 20.121C15.243 21 13.828 21 11 21H7C4.172 21 2.757 21 1.879 20.121C1 19.243 1 17.828 1 15V7Z",
    stroke: "#FD8238",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.898 15H4.898C3.968 15 3.503 15 3.121 15.102C2.61231 15.2384 2.14849 15.5063 1.77618 15.8788C1.40386 16.2513 1.13616 16.7152 1 17.224",
    stroke: "#FD8238",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H13M5 9.5H10",
    stroke: "#FD8238",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.d93a685c68ab5f20c831c734b97f6e30.svg";
export { ForwardRef as ReactComponent };